import clsx from 'clsx';
import { Button } from './Button';

export const ButtonGroup = ({ label, id, options, currentValue, handleChange, format = null }) => {
  const handleRadioChange = optionId => {
    handleChange(optionId);
  };

  return (
    <div role="radiogroup" aria-labelledby={`${id}-radio-group`} className="mt-6">
      <div className="flex gap-2 items-baseline justify-center">
        {label && (
          <label id={`${id}-radio-group`} className="font-bold  text-center">
            {label}
          </label>
        )}
      </div>
      <hr></hr>

      <div className={clsx(format ? 'flex flex-col gap-2' : 'flex flex-wrap gap-4', ' my-3 justify-center')}>
        {options.map(option => {
          const isSelected = currentValue === option.id;

          return (
            <Button
              key={option.id}
              type="button"
              inverted={!isSelected}
              square
              onClick={() => handleRadioChange(option.id)}
              aria-pressed={isSelected}
            >
              {option.label}
            </Button>
          );
        })}
      </div>
    </div>
  );
};
